import artifactContent from '../../../ui/i18n/ns/artifact-content.ts';
import { scalarSchema } from '../models/value.mjs';

const REASON_KEYS = Object.freeze({
  'source-null': 'valueSourceNull',
  missing: 'valueMissing',
  redacted: 'valueRedacted',
});
const STYLES = new Set(['dash', 'blank', 'explicit']);
const DEFAULTS = Object.freeze({
  table: 'dash',
  kpi: 'dash',
  prose: 'explicit',
  document: 'explicit',
});

/** Same primary-language/English fallback as the interface catalog resolver.
 * Reads the existing namespace; there is no second translated dictionary.
 */
export function projectNullCatalog(locale) {
  let language;
  try {
    language = new Intl.Locale(locale || 'en').language;
  } catch {
    language = 'en';
  }
  const catalogLocale = Object.hasOwn(artifactContent, language) ? language : 'en';
  const copy = artifactContent[catalogLocale];
  return Object.freeze({
    catalogLocale,
    labels: Object.freeze(
      Object.fromEntries(Object.entries(REASON_KEYS).map(([reason, key]) => [reason, copy[key]])),
    ),
  });
}

/** Display only. Office/CSV data cells keep the parsed null scalar/reason. */
export function projectNullDisplay(scalar, { locale, surface, nullStyle } = {}) {
  const parsed = scalarSchema.parse(scalar);
  if (parsed.kind !== 'null') throw new TypeError('null_scalar_required');
  const style = nullStyle ?? DEFAULTS[surface];
  if (!STYLES.has(style)) throw new TypeError('null_display_style_required');
  const label = projectNullCatalog(locale).labels[parsed.reason];
  return Object.freeze({
    reason: parsed.reason,
    text: style === 'dash' ? '\u2014' : style === 'blank' ? '' : label,
    accessibleLabel: label,
    muted: true,
  });
}
